const normTeam = (value) => {
  if (typeof value === 'string') return value.trim().toLowerCase();
  if (value == null) return '';
  return String(value).trim().toLowerCase();
};

const bookingEntityKey = (booking) =>
  booking.idPlayer || booking.idCoach || booking.idStaff || '';

export const conductPenaltyFromBookings = (bookings) => {
  let total = 0;
  const yellowByKey = new Set();

  (bookings || []).forEach((booking) => {
    const key = bookingEntityKey(booking);
    if (booking.card === 1) {
      total -= 1;
      if (key) yellowByKey.add(key);
    } else if (booking.card === 2) {
      total -= key && yellowByKey.has(key) ? 3 : 4;
    }
  });

  return total;
};

export const getTeamConductScore = (team, groupMatches) => {
  const code = normTeam(team);
  if (!code) return 0;

  return (groupMatches || []).reduce((sum, match) => {
    if (normTeam(match.teamHome) !== code && normTeam(match.teamAway) !== code) {
      return sum;
    }
    const teamBookings = (match.bookings || []).filter(
      (booking) => normTeam(booking.team) === code
    );
    return sum + conductPenaltyFromBookings(teamBookings);
  }, 0);
};

export const byFairPlay = (groupMatches) => (a, b) =>
  getTeamConductScore(b.team, groupMatches) - getTeamConductScore(a.team, groupMatches);
